import {createContext} from "react";
import {CreateNewEntityController} from "./CreateNewEntityController";

export const CreateNewEntityContext =
  createContext<CreateNewEntityController | null>(null);
